import axios from "axios";

import { GAMBLING } from "../constants";
import {
  GET_DEBIT_CARD_MERCHANT_CONTROL,
  SET_DEBIT_CARD_MERCHANT_CONTROL,
} from "../graph/queries";
import { IApiHeaders, IConfiguration } from "../interfaces";

const createQueryHeaders = (headers: IApiHeaders) => ({
  headers: {
    ContentType: "application/json",
    Authorization: headers.authToken,
  },
});

const generateGetQuery = (
  headers: IApiHeaders,
  tokenisedDebitCardNumber: string
) => ({
  query: GET_DEBIT_CARD_MERCHANT_CONTROL,
  fetchPolicy: "network-only" as const,
  variables: { merchantControlType: GAMBLING, tokenisedDebitCardNumber },
  context: createQueryHeaders(headers),
});

const generateSetQuery = (
  headers: IApiHeaders,
  tokenisedDebitCardNumber: string,
  declineAll: boolean
) => ({
  mutation: SET_DEBIT_CARD_MERCHANT_CONTROL,
  variables: {
    tokenisedDebitCardNumber,
    controlType: GAMBLING,
    declineAll,
  },
  context: createQueryHeaders(headers),
});

export const fetchJSONData = async () => {
  return await axios.get(
    `${process.env.PUBLIC_URL}/assets/cmsStaticContent.json`
  );
};

export const fetchGamblingControl = async (
  headers: IApiHeaders,
  tokenisedDebitCardNumber: string
) => {
  const { client } = headers;
  const queryResponse = await client.query(
    generateGetQuery(headers, tokenisedDebitCardNumber)
  );
  return queryResponse;
};

export const updateGamblingControl = async (
  headers: IApiHeaders,
  tokenisedDebitCardNumber: string,
  declineAll: boolean
) => {
  const { client } = headers;
  const queryResponse = await client.mutate(
    generateSetQuery(headers, tokenisedDebitCardNumber, declineAll)
  );
  return queryResponse;
};

// @TODO: This is temporary solution to get the specific env and set in window. Will be handle in #DIGI-23105
export const getEnvConfig = async (env: string) => {
  const emptyConfig: IConfiguration = {
    ANALYTICS_SCRIPT_URL: "",
    GRAPH_GATEWAY_URL: "",
    IB_URL: "",
    ON_START_EVENT_OCCURANCE_LIMIT: 0,
    ON_START_INTERVAL: 0,
  };
  await axios
    .get(`./config${env}.json`)
    .then((response) => {
      window.configuration = response.data || emptyConfig;
    })
    .catch(() => {
      window.configuration = emptyConfig;
    });
};
